'use client';
import { isFunction, omitUndefined } from '@s7/utils';
import { useTheme } from '../../theming/propagation/ThemeProvider.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function useProps(__ident, props, defaultProps) {
    var _theme_components___ident, _theme_components, _defaultProps_presets, _theme_components___ident_presets, _theme_components___ident1, _theme_components1;
    const theme = useTheme();
    const _themeProps = (_theme_components = theme.components) == null ? void 0 : (_theme_components___ident = _theme_components[__ident]) == null ? void 0 : _theme_components___ident.props;
    const presetName = (props == null ? void 0 : props.preset) || (defaultProps == null ? void 0 : defaultProps.preset);
    // FIXME: https://kaiten.s7.ru/space/84/boards/card/555940
    const presetProps = _extends({}, defaultProps == null ? void 0 : (_defaultProps_presets = defaultProps.presets) == null ? void 0 : _defaultProps_presets[presetName], theme == null ? void 0 : (_theme_components1 = theme.components) == null ? void 0 : (_theme_components___ident1 = _theme_components1[__ident]) == null ? void 0 : (_theme_components___ident_presets = _theme_components___ident1.presets) == null ? void 0 : _theme_components___ident_presets[presetName]);
    const themeProps = isFunction(_themeProps) ? _themeProps(theme) : _themeProps;
    const mergedProps = _extends({}, defaultProps, themeProps, presetProps, omitUndefined(props));
    const { classNames, styles, size, variant, preset, presets } = mergedProps, others = _object_without_properties_loose(mergedProps, [
        "classNames",
        "styles",
        "size",
        "variant",
        "preset",
        "presets"
    ]);
    return [
        others,
        {
            classNames,
            styles,
            size,
            variant,
            preset
        }
    ];
}

export { useProps };
//# sourceMappingURL=useProps.js.map
